import { ReactElement } from 'react';
import { ILeadInfoRowProps } from '.';

export const LeadInfoRow = ({ label, value, defaultValue = '-' }: ILeadInfoRowProps): ReactElement => (
	<li className="row">
		<span className="d-col d-col-6 about-heading">{label}</span>
		<span className="d-col d-col-6 about-info">
			{value !== null && value !== undefined && value !== '' ? value : defaultValue}
		</span>
	</li>
);
